<template>
  <div class="loading-overlay" v-if="visible">
    <p>
      <v-progress-circular indeterminate color="brand" size="150" :width="1" />
    </p>
  </div>
</template>

<script>
  export default {
    name: 'LoadingSpinner',
    props: {
      visible: {
        type: [Boolean, Number],
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .loading-overlay {
    z-index: 9999;
    position: fixed;
    top: 0; left: 0; bottom: 0; right: 0;
    display: flex;
    background-color: rgba(100%, 100%, 100%, .8);
    p {
      margin: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/LoadingSpinner.vue